import LockSVG from '../../icons/LockSVG'
import { PerformanceLabel } from '../../types/mutual-fund-detail.types'

export type ScoreStatus = 'IN_FORM' | 'ON_TRACK' | 'OFF_TRACK' | 'OUT_OF_FORM' | 'PERFORMANCE_LOCKED' | 'NOT_RATED'

interface EliteScoresProps {
  value: number | string
  status: ScoreStatus
  className?: string
  performanceLabel: PerformanceLabel
}

const statusStyles: Record<PerformanceLabel, { bg: string; text: string; svgColor: string }> = {
  GREAT: {
    bg: 'bg-status-in-form',
    text: 'text-status-text-in-form',
    svgColor: '#7ECA94'
  },
  GOOD: {
    bg: 'bg-status-on-track',
    text: 'text-status-text-on-track',
    svgColor: '#90DCA6'
  },
  AVERAGE: {
    bg: 'bg-status-off-track',
    text: 'text-status-text-off-track',
    svgColor: '#F0AAA0'
  },
  BAD: {
    bg: 'bg-status-out-of-form',
    text: 'text-status-text-out-of-form',
    svgColor: '#F0AAA0'
  },
  UNKNOWN: {
    bg: 'bg-[#F6F9F9]',
    text: 'text-black',
    svgColor: '#6A6E6E'
  }
}

export default function EliteScores({ value, status, className = '', performanceLabel }: EliteScoresProps) {
  const { text, bg } = statusStyles[performanceLabel as PerformanceLabel] || {
    bg: 'bg-[#F6F9F9]',
    text: 'text-black'
  }
  return (
    <div className='flex flex-row'>
      <div
        className={`w-[50px] h-16 ${bg} ${className} relative rounded-sm flex-shrink-0`}
        aria-label={`Score: ${value}, Status: ${status}`}
      >
        {status === 'NOT_RATED' ? (
          <div className='inline-flex items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
            <span
              className={`text-xs ${value ? text : 'text-grey40'} relative bottom-0 font-medium ${value ? '' : 'opacity-50'}`}
            >
              {value || '-'}
            </span>
          </div>
        ) : status === 'PERFORMANCE_LOCKED' ? (
          <div className='inline-flex items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
            <LockSVG color={'#D1D6D6'} />
          </div>
        ) : (
          <div className='inline-flex items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
            {value || value === null ? (
              <span
                className={`text-[13px] ${value ? text : 'text-grey40'} relative bottom-0 font-medium ${value ? '' : 'opacity-50'}`}
              >
                {value || '-'}
              </span>
            ) : (
              <>
                {/* unlockFundBottomSheets call disabled to avoid triggering bottom sheet */}
                <span className={`text-[13px] ${text} relative bottom-0`}>
                  <LockSVG color={'#D1D6D6'} />
                </span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
